import _get from 'lodash/get';

export const loaderDomain = ({ root }) => _get(root, 'globalLoader') || {};

export const rootDomain = ({ root }) => root || {};

export const appDataDomain = ({ Data }) => Data || {};

export const translationsDomain = ({ root }) => _get(root, 'translations') || {};

export const addCarDomain = ({ root }) => _get(root, 'addCar') || {};

export const removeCarDomain = ({ root }) => _get(root, 'removeCar') || {};
